export default {
  id_nav_title: "身分認證",
  basic_nav_title: "基礎資訊",
  work_nav_title: "工作資訊",
  other_nav_title: "其他資訊",
  work_Fill_in_the_information_below: "請認真填寫下方資料",
  work_work_messages: "工作資訊",
  work_company_information: "公司資訊",
  work_upload_certificate: "上傳工作證明",
  work_job_type: "工作類型",
  work_p_job_type: "請選擇工作類型",
  work_income_level: "薪資等級",
  work_s_income_level: "請選擇薪資等級",
  work_job_time: "工作年資",
  work_p_job_time: "請選擇工作年資",
  work_company_name: "公司名稱",
  work_p_company_name: "請輸入公司名稱",
  work_company_phone: "公司電話",
  work_p_company_phone: "請輸入公司電話",
  work_company_mail: "信箱",
  work_p_company_mail: "請輸入信箱",
  work_company_area: "公司地區",
  work_s_company_area: "請選擇公司地區",
  work_company_area_info: "詳細位址",
  work_p_company_area_info: "請輸入詳細位址",
  work_company_card: "工作證明",
  work_p_update_company_card: "請上傳工作證明",
  work_next_btn: "下一步",
  work_next_msg: "請上傳工作證明",
  work_face_recognition: "請進行人臉辨識",
  work_submit_success: "提交成功"
}